import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

export const QuizQuestion = ({ step, question, currentAnswer, loading, onChoose, onBack }) => (
  <div className="grid grid-cols-12 gap-6 lg:gap-12 fade-up" key={step} data-testid={`quiz-step-${step}`}>
    <div className="col-span-12 lg:col-span-5">
      <div className="micro-label text-[#1a1814]/60 mb-3">Question {step + 1}</div>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1a1814] leading-tight">{question.label}</h2>
      <p className="text-[#1a1814]/65 mt-3 sm:mt-4 italic text-sm sm:text-base">{question.helper}</p>

      <div className="mt-8 sm:mt-10 flex gap-3">
        {step > 0 && (
          <button
            type="button"
            onClick={onBack}
            className="micro-label inline-flex items-center gap-2 text-[#1a1814]/60 hover:text-[#1a1814]"
            data-testid="quiz-back-btn"
          >
            <ArrowLeft className="w-3 h-3" /> Back
          </button>
        )}
      </div>
    </div>

    <div className="col-span-12 lg:col-span-7 space-y-3" role="radiogroup" aria-label={question.label}>
      {question.options.map((opt) => {
        const isSelected = currentAnswer === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChoose(opt.id)}
            disabled={loading}
            className={`w-full text-left group p-5 sm:p-6 border transition-colors ${
              isSelected ? "border-[#1a1814] bg-[#1a1814] text-[#f0e9e1]" : "border-[#1a1814]/15 bg-[#efe6db] hover:border-[#1a1814]"
            }`}
            data-testid={`quiz-option-${question.key}-${opt.id}`}
          >
            <div className="flex justify-between items-start gap-4 sm:gap-6">
              <div>
                <div className={`font-serif text-lg sm:text-xl ${isSelected ? "text-[#f0e9e1]" : "text-[#1a1814]"}`}>{opt.label}</div>
                <div className={`text-sm mt-1 ${isSelected ? "text-[#f0e9e1]/70" : "text-[#1a1814]/65"}`}>{opt.sub}</div>
              </div>
              <ArrowRight className={`w-4 h-4 mt-1 shrink-0 transition-transform group-hover:translate-x-1 ${isSelected ? "text-[#f0e9e1]" : "text-[#1a1814]/50"}`} />
            </div>
          </button>
        );
      })}
      {loading && <div className="micro-label text-[#1a1814]/60">Drafting your capsule…</div>}
    </div>
  </div>
);
